import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default async function getClienteEstoqueModulo(ClienteId: number) {
  const { data } = await api.get(`${URLS.ESTOQUE_API}`, {
    params: {ClienteId}
  });
  return data;
}
